import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { Message } from 'src/app/core/class/message';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';

@Component({
  selector: 'app-create-group-customer',
  templateUrl: './create-group-customer.component.html',
  styleUrls: ['./create-group-customer.component.scss']
})
export class CreateGroupCustomerComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  filterKey: string = ''
  searchControl: FormControl;
  groupNameControl: FormControl;
  groupName: string = ''
  description: string = '';
  isFormChanging: boolean = false;
  displayedColumns: string[] = [];
  isAddCustomer: boolean = false
  inputCustomerValue: string;
  filteredCustomerOptions = [];
  nzCheckLoadingCustomer = false;
  selectedCustomer = []
  columnDefinitions = [
    { def: "id", showMobile: true },
    { def: "name", showMobile: true },
    { def: "certificateNo", showMobile: true },
    { def: "email", showMobile: true },
    { def: "action", showMobile: true },
  ];
  filterRow = ['stt', 'filterName', 'filterCertificate', 'filterEmail', 'actionFilter']
  filterForm = {
    name: '',
    certificateNo: '',
    email: '',
  }
  groupCustomerId: string = ''
  groupCustomerName: string = ''
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  isShowFilter: boolean = false
  paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  error = '';
  subscription: Subscription;



  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChildren('focusInput') focusInput;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  constructor(public notificationService: NotificationService,
    public dialog: MatDialog,
    private customerService: CustomerService,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private message: Message,
    private toastr: ToastrService,
    private breadcrumbsService: BreadcrumbsService,
    private storageService: StorageService,
    public customerFilter: CustomerFilterLanguage,
    private responsiveService: ResponsiveService,
    public deviceService: DeviceDetectorService,) {
    this.groupCustomerId = this.route.snapshot.paramMap.get('id');

    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
  }

  ngOnInit() {
    this.searchControl = new FormControl();
    this.groupNameControl = new FormControl('', Validators.required);
    this.onFilterCustomers(0, this.paginate.pageSize);

    if (this.groupCustomerId) {
      this.getGroupDataByID();
      this.breadcrumbsService.store([
        { label: 'breadcrumbs.home', url: 'analysis-report', params: [], highlight: false },
        { label: 'breadcrumbs.management_customer', url: '', params: [], highlight: false },
        { label: 'breadcrumbs.enterprise_group_customer', url: 'group-customers', params: [], highlight: false },
        { label: 'breadcrumbs.enterprise_manage_group_customer', url: '', params: [], highlight: false },
      ]);
    }else{
      this.breadcrumbsService.store([
        { label: 'breadcrumbs.home', url: 'analysis-report', params: [], highlight: false },
        { label: 'breadcrumbs.management_customer', url: '', params: [], highlight: false },
        { label: 'breadcrumbs.enterprise_group_customer', url: 'group-customers', params: [], highlight: false },
        { label: 'breadcrumbs.enterprise_create_group_customer', url: '', params: [], highlight: false },
      ]);
    }
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  openFilter() {
    this.isShowFilter = !this.isShowFilter;
    if (!this.isShowFilter) {
      this.filterForm = {
        name: '',
        certificateNo: '',
        email: '',
      }
      this.onFilterCustomers();
    }
  }

  ngOnDestroy() {
    // this.notificationService.unsubscribeErrorService();
    // this.subscribeMediaBreakPointService.unsubscribe();
  }

  getGroupDataByID() {
    this.customerService.detailGroupCustomer({ id: this.groupCustomerId }).subscribe(rs => {
      if (rs && rs.success) {
        this.groupName = rs.data.name
      }
    })
  }

  onChangeCustomerSearch($event) {
    let body;
    if (this.groupCustomerId) {
      body = {
        page: 0,
        pageSize: 10,
        groupCustomerId: this.groupCustomerId,
        keyword: this.inputCustomerValue
      }
    } else {
      body = {
        page: 0,
        pageSize: 10,
        customerIds: this.selectedCustomer.map(item => item.id),
        keyword: this.inputCustomerValue
      }
    }
    this.nzCheckLoadingCustomer = true;
    this.customerService.filterCustomer(body)
      .subscribe(result => {
        this.filteredCustomerOptions = result.data.dataRow;
        this.nzCheckLoadingCustomer = false;
      }, error => {
        this.nzCheckLoadingCustomer = false;
      });
  }

  // Thêm user
  autocompleteCustomerSelected($event: any, model: any) {
    if ($event.isUserInput) {
      this.isFormChanging = true;
      if (this.groupCustomerId) {
        //gán kh
        const body = {
          customerIds: [model.id],
          groupCustomerIds: [this.groupCustomerId]
        }
        this.customerService.assignCustomerToGroup(body).subscribe(rs => {
          if (rs && rs.success) {
            this.filterForm = {
              name: '',
              certificateNo: '',
              email: '',
            }
            this.toastr.success(this.message.getMessage('messages.add_into_group_success'));
            this.onChangeCustomerSearch('');
            this.onFilterCustomers(0, this.paginate.pageSize);
          } else {
            this.toastr.error(rs.message);
            if(rs.code == ErrorCode.GroupCustomerRemoved || rs.code == ErrorCode.GroupCustomerDeleted){
              this.router.navigate(['/home-enterprise/group-customers'], {
              });
            }
            if(rs.code == ErrorCode.ErrorInUpdateCustomer){
              this.filterForm = {
                name: '',
                certificateNo: '',
                email: '',
              }
              this.onChangeCustomerSearch('');
              this.onFilterCustomers(0, this.paginate.pageSize);
            }
          }
        })
      } else {
        this.selectedCustomer.unshift(model);
        this.onChangeCustomerSearch('');
        this.onFilterCustomers()
      }
    }
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status' && cd.def !== 'check'))
    //     .map(cd => cd.def);
    // }
  }

  /**
   * On click button delete customer
   */
  onClickIconDelete(customerId: number, customerName: string, index?: number) {

    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_customer_in_group_1'), customerName)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        if (!this.groupCustomerId) {
          this.selectedCustomer = this.selectedCustomer.filter(item => item.id !== customerId);
          this.toastr.success(this.message.getMessage('messages.delete_customer_success'));
          this.onFilterCustomers();
        } else {
          const body = {
            customerIds: [customerId],
            groupCustomerIds: [this.groupCustomerId]
          }
          this.customerService.deleteCustomerGroup(body).subscribe(
            (rs) => {
              if (rs && rs.success) {
                this.toastr.success(this.message.getMessage('messages.delete_customer_success'));
                if (this.paginate.totalRow % this.paginate.pageSize === 1) {
                  if (this.paginate.currentPage - 1 < 0) {
                    this.paginate.currentPage = 0;
                  } else {
                    this.paginate.currentPage = this.paginate.currentPage - 1;
                  }
                }
                this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
              } else {
                this.toastr.error(rs.message);
                if(rs.code == ErrorCode.ErrorInUpdateCustomer1){
                  if (this.paginate.totalRow % this.paginate.pageSize === 1) {
                    if (this.paginate.currentPage - 1 < 0) {
                      this.paginate.currentPage = 0;
                    } else {
                      this.paginate.currentPage = this.paginate.currentPage - 1;
                    }
                  }
                  this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
                }
              }
            }
          );
        }
      }
      this.focusInput.first.nativeElement.focus();
    });
  }

  /**
   * Filter customer
   */

  onFilterCustomers(page: number = 0, pageSize: number = 10) {
    if (this.groupCustomerId) {
      const body = {
        page,
        pageSize,
        name: this.filterForm.name.trim().toLowerCase() || '',
        certificateNo: this.filterForm.certificateNo.trim().toLowerCase() || '',
        email: this.filterForm.email.trim().toLowerCase() || '',
        groupCustomerId: this.groupCustomerId
      }
      this.customerService.getCustomerOfGroup(body).subscribe(
        rs => {
          this.bindData(rs);
        }
      );
    } else {
      let data = this.selectedCustomer.filter(item => {
        if (item.name.toLowerCase().includes(this.filterForm.name.trim().toLowerCase() || '')
          && item.certificateNo.toLowerCase().includes(this.filterForm.certificateNo.trim().toLowerCase() || '')
          && (item.email && item.email.toLowerCase().includes(this.filterForm.email.trim().toLowerCase() || '') || !item.email)) {
          return item;
        }
      }) || []
      this.dataSource.data = data
    }
  }

  /**
   * Bind data from api
   */
  private bindData(rs: any) {
    if (rs == null || rs.data == null || rs.data.dataRow == null) {
      return 0;
    }
    this.paginate = {
      currentPage: rs.data.currentPage,
      pageSize: rs.data.pageSize,
      totalRow: rs.data.totalRow,
      totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
      totalPageArray: this.commonService.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
      no: this.commonService.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
    };

    rs.data.dataRow.forEach(async(row) => {
      if(row.syncStatus === 'SYNCED')
      row.syncStatusMessage = await this.commonService.getMessage('system_document_template.cbx_document_status.cbx_document_status_synced');
      else if (row.syncStatus === 'NOT_SYNCED')
      row.syncStatusMessage =  await this.commonService.getMessage('system_document_template.cbx_document_status.cbx_document_status_not_synced');
    });
    this.dataSource.data = rs.data.dataRow;
  }

  onNoClick() {
    if (this.isFormChanging && !this.groupCustomerId) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.router.navigate(['/home-enterprise/group-customers'], {
          });
        }
        dialogRe.close();
      });
    } else {
      this.router.navigate(['/home-enterprise/group-customers'], {
      });
    }
  }

  onCreateClick() {
    if (!this.groupName || !this.groupName.trim()) {
      this.groupNameControl.markAsTouched()
      return;
    }
    this.blockUI.start('')
    let customerIds = []
    if (this.selectedCustomer.length) {
      this.selectedCustomer.forEach(item => customerIds.push(item.id))
    }
    const body = {
      name: this.groupName,
      description: this.description,
      customerIds: customerIds
    }
    this.customerService.groupCustomerCreate(body).subscribe(rs => {
      this.blockUI.stop()
      if (rs && rs.success) {
        this.toastr.success(this.message.getMessage('messages.create_group_customer_success'))
        this.router.navigate(['/home-enterprise/group-customers'])
      } else {
        this.toastr.error(rs.message)
      }
    })
  }

  checkIndexOfElement(element){
    const index = this.dataSource.filteredData.indexOf(element) + 1
    if((this.isShowFilter && index % 2 !== 0) || (!this.isShowFilter && index % 2 == 0)){
      return true
    }
    return false
  }

  isSMEHubAccount(): boolean {
    return localStorage.getItem('isFromSSO') == 'true';
  }
}
